import React from "react"

import OtherNavbar from "components/Navbars/OtherNavbar.js"
import Footer from "components/Footers/Footer.js"

import { Container } from "reactstrap"

class Terms extends React.Component {
  render() {
    return (
      <>
        <div>
          <OtherNavbar />
          <div className="main-content mt-4">
            <Container>
              <h1>Terms of Service</h1>
              <i>Last Revised: January 15, 2021</i>
              <h2 className="mt-4">
                SECTION 1: INTRODUCTION &amp; ACCEPTANCE OF TERMS
              </h2>
              <p>
                These Terms of Service (the <b>“Terms”</b>) are an agreement
                between you or the entity you represent (“<b>you</b>,” “
                <b>your</b>,” or “<b>user</b>”) and New Vices LLC DBA Faver, a
                limited liability company governed by the laws of the State of
                California, USA (“<b>Faver</b>,” ”<b>we</b>," “<b>our</b>,” or “
                <b>us”</b>). We own and operate the website www.needafaver.com
                and mobile applications “Faver” and “Faver Merchant”
                (collectively, “<b>Platform”</b>).{" "}
              </p>
              <p>
                By accessing or using any part of the Platform, you agree to be
                bound by these Terms. If you do not accept these Terms and all
                the policies and documents incorporated herein by reference in
                their entirety, you may not use any part of the Platform.
              </p>
              <p>
                To the extent permitted by applicable law, we may, at any time,
                amend these Terms, including any features or functionality of
                the Platform, without prior notice to you, by posting a revised
                version of the Terms and/or a notification about changes made to
                features or functionality of the Platform. Any revisions to
                these Terms or changes to the Platform will take effect when a
                revised version or a notification is posted on the Platform
                unless otherwise stated. Your continued use of the Platform
                after the revision date constitutes (a) your acceptance of
                revised Terms and/or changes in Platform and (b) agreement to be
                bound by any such revised terms and conditions.
              </p>
              <h2 className="mt-4">SECTION 2: HOW THE PLATFORM WORKS</h2>
              <p>
                The Platform is an online marketplace and a directory for car
                wash and car detailing services. All such services listed on the
                Platform shall be referred to as the “<b>Service(s)</b>”. A user
                purchasing a Service through the Platform shall be referred to
                as a “<b>Client</b>” in these Terms. Any user offering or
                promoting a Service on the Platform shall be referred to as a “
                <b>Service Provider</b>” in these Terms.
              </p>
              <p>
                A Client may choose any Service available on the Platform and
                book it. It is up to a Client and Service Provider to mutually
                determine the location of the Service.
              </p>
              <p>
                Users of the Platform are solely responsible for all
                interactions, conversations, and any form of communication and
                behavior between one another. The Platform is separate and
                distinct from the Services offered by the Service Providers. We
                do not endorse, hire or employ any Service Provider nor are we
                responsible or liable for any interactions between any such
                Service Provider and its Clients.
              </p>
              <p>
                We reserve the right to remove any Service or terminate any
                user’s Account (as defined below) if we believe that any such
                Service or user violated these Terms or any policy incorporated
                herein by reference.
              </p>
              <h2 className="mt-4">
                SECTION 3: WHO MAY USE &amp; REGISTER ON PLATFORM
              </h2>
              <p>
                Only individuals who reached the age of majority in their state
                of residence may sign up for an Account (as defined below) on
                the Platform. Moreover, Service Providers have to have
                authorization to work in the US.{" "}
              </p>
              <h2 className="mt-4">
                SECTION 4: PROVISIONS RELATING TO SERVICES
              </h2>
              <p>
                <b>Description of Services and Pricing.</b> Service Providers
                are solely responsible for:
              </p>
              <ul>
                <li>providing accurate Service description, and</li>
                <li>setting Service rates.</li>
              </ul>
              <p>
                Service descriptions and rates on the Platform are subject to
                change without notice. Clients shall honor the prices
                established at the time of booking.
              </p>
              <p>
                <b>Service Agreement.</b> A complete booking shall constitute an
                agreement (“Service Agreement”) between the Client and its
                Service Provider. Each Service Agreement contains the terms and
                the scope of work to be performed.{" "}
              </p>
              <p>
                <b>Quality of Service.</b> Each Service Provider shall perform
                each Service (i) in a workmanlike and professional manner, (ii)
                with the same degree of care as it exercises in performing its
                own functions of a like or similar nature, (iii) utilizing
                individuals of suitable experience, training and skill, and (iv)
                in a timely manner in accordance with the terms agreed by and
                between the Service Provider and its Client.
              </p>
              <p>
                <b>Payment Terms.</b> Faver will handle all payments on behalf
                of Service Providers. Acceptable forms of payment: credit/debit
                cards, Apple Pay, and Google Pay. The Client’s preferred payment
                method will be charged at the time of booking using our trusted
                partner Stripe.
              </p>
              <p>
                <b>SMS communication.</b> The Platform allows Clients and
                Service Providers to communicate and negotiate Service
                Agreements via SMS/text messages. Faver will not charge you for
                text messages, however, you may incur SMS usage charges from
                your service provider depending on the type of data/rate plan
                you are currently on.
              </p>
              <p>
                <b>Cancellation Policy.</b> Clients have an opportunity to
                cancel any booking up to one hour prior to the scheduled time of
                the Service and receive a full refund. If you forget to cancel a
                Service at least one hour before the scheduled time of the
                Service, no refunds will be issued.
              </p>
              <h2 className="mt-4">SECTION 5: YOUR ACCOUNT</h2>
              <p>
                <b>Registering for Account.</b> You may get access to all
                features of the Platform by signing up for an account (“
                <b>Account</b>”). When you register for an Account, you will be
                asked to provide certain information about yourself. By
                registering for an Account, you represent and warrant that: (a)
                all required information you submit is truthful and accurate,
                (b) you will maintain the accuracy of such information, (c) you
                do not impersonate any person or entity, including any Faver’s
                employees or representatives, and (d) you have reached the age
                of majority in your state of residence.{" "}
              </p>
              <p>
                <b>Registering as Entity.</b> If you register for an Account on
                behalf of an entity, you represent and warrant that you have the
                authority to bind that entity to this Agreement. In that event,
                "you," "your," or “user” will refer and apply to that entity.{" "}
              </p>
              <p>
                <b>Confidentiality and Security of Your Login Information.</b>{" "}
                You shall be responsible for (i) maintaining and ensuring the
                confidentiality and security of your Account’s login
                information, and (ii) all activities that are conducted under
                your Account. By using your Account, you acknowledge and agree
                that our account security procedures are commercially
                reasonable. You agree to immediately notify us in the event of
                any unauthorized use, or suspected unauthorized use, of your
                Account or any other breach of security. We cannot and will not
                be liable for any loss or damage arising from your failure to
                keep your login information in confidence.
              </p>
              <h2 className="mt-4">SECTION 6: LICENSE TO USE PLATFORM</h2>
              <p>
                License.<b></b> Subject to the terms and conditions of these
                Terms, Faver grants you a worldwide, non-transferable and
                non-exclusive license of the right to use the Platform.
              </p>
              <p>
                <b>Restricted Uses.</b> The right granted to you in the present
                Terms is subject to the following restrictions:{" "}
              </p>
              <ol>
                <li>
                  you shall not sublicense, sell, rent, lease, transfer, assign,
                  or share your Account to any third party;{" "}
                </li>
                <li>
                  you shall not permit anyone else whose Account was terminated,
                  or who is not a registered user, to use the Platform through
                  your Account;
                </li>
                <li>you shall not create more than one Account;</li>
                <li>
                  you shall not copy, modify, translate, adapt, merge, make
                  derivative works of, disassemble, decompile, reverse compile
                  or reverse engineer any part of the Platform;{" "}
                </li>
                <li>
                  you shall not access the Platform in order to build a similar
                  or competitive service/platform/website/application;
                </li>
                <li>
                  you shall not impersonate other individuals or provide
                  inaccurate information about yourself;
                </li>
                <li>
                  you shall not represent an entity without its prior
                  authorization to do so;{" "}
                </li>
                <li>
                  you shall not engage in anything unlawful, misleading, or
                  fraudulent or for illegal or unauthorized purpose;{" "}
                </li>
                <li>
                  you shall not violate or encourage others to violate laws,
                  third party rights, these Terms and policies incorporated
                  herein by reference;
                </li>
                <li>
                  you shall not solicit any user to use another online
                  platform/website for provision or obtaining car wash and car
                  detailing services;{" "}
                </li>
                <li>
                  you shall not express or imply that any statements you make
                  are endorsed by us, without our prior written consent;{" "}
                </li>
                <li>
                  you shall not engage in any sexual conduct or any
                  communication which contains nudity or expresses profanity;
                </li>
                <li>
                  you shall not upload, distribute, or transmit any computer
                  viruses, worms, Trojan horses, malicious code, or any software
                  intended to damage or alter a computer system or a mobile
                  device or data;
                </li>
                <li>
                  you shall not retrieve, index, "data mine," or collect
                  information or data of other users, including their email
                  addresses, (e.g., using any harvesting bots, robots, spiders,
                  or scrapers, site search/retrieval applications, or other
                  manual or automatic devices);
                </li>
                <li>
                  you shall not disable, overburden, impair, or otherwise
                  interfere with servers or networks connected to the Platform
                  (e.g., a denial of service attack);{" "}
                </li>
                <li>
                  you shall not attempt to gain unauthorized access to the
                  Platform or servers or networks connected to the Platform
                  (e.g., through password mining);
                </li>
                <li>you shall not engage in spamming or flooding;</li>
                <li>
                  you shall not "frame" or "mirror" any part of the Platform;
                  and{" "}
                </li>
                <li>
                  you shall not restrict or inhibit any other user’s use and
                  enjoyment of the Platform, including, without limitation, by
                  means of "hacking" or "cracking" or defacing any portion of
                  the Platform;
                </li>
              </ol>
              <p>
                Violation of any of the above may be subject to termination of
                your Account or suspension of your access to the Platform.
              </p>
              <p>
                <b>Ownership.</b> We and our licensors (if any and where
                applicable) own all right, title and interest, including all
                related intellectual property rights, in and to the Platform.
                The Platform is licensed to you; this means that the Platform is
                under no circumstances sold/transferred to you. Indeed, the
                present Terms do not convey to you any rights of ownership in or
                related to the Platform. Our name, logo, and other names
                associated with the Platform belong to us (or our licensors, if
                any and where applicable), and no license of the right to use
                them by implication, estoppel or otherwise is granted to you
                hereunder. We (and our licensors, if any and where applicable)
                reserve all rights not granted in these Terms.
              </p>
              <h2 className="mt-4">SECTION 7: YOUR CONTENT; REVIEWS</h2>
              <p>
                <b>Content.</b> Any Service Provider may create, upload, post,
                display, share, and otherwise make available certain
                information, graphics, videos, or other materials on the
                Platform (collectively, "<b>Content</b>"). Service Providers are
                solely responsible for the Content they create, upload, post,
                display, share or otherwise make available on or through the
                Platform, including its accuracy, legality, and appropriateness
                and we do not assume any liability for any Content posted by any
                Service Provider. Moreover, the Platform allows Clients to post
                Service <b>reviews</b> and to rate Services. All such reviews
                and ratings of Services are considered to constitute{" "}
                <b>Content</b>.
              </p>
              <p>
                <b>
                  Your Representations and Warranties with Regard to Your
                  Content.
                </b>{" "}
                By posting or making your Content available via the Platform,
                you represent and warrant that: (i) you own the Content and/or
                you have the right to use it and the right to grant us and other
                users of the Platform the license as provided below; (ii) by
                creating, uploading, posting, displaying or sharing Content on
                or through the Platform you do not violate any law, privacy
                rights, publicity rights, copyrights, contract rights or any
                other rights of any person or entity; (iii) your Content does
                not and will not contain sexually explicit content or
                pornography; (iv) your Content does not contain hateful,
                defamatory, discriminatory, unlawful, fraudulent, threatening,
                harassing, abusive, libelous, defamatory, obscene or otherwise
                objectionable information or imagery and does not incite hatred
                against any individual or group, and (v) your Content does not
                contain any solicitations, chain letters, pyramid schemes,
                investment opportunities, or other unsolicited commercial
                communication (except as otherwise expressly permitted by us).
              </p>
              <p>
                <b>Ownership of Content.</b> You and your licensors (if any)
                retain any and all of your rights to any Content you upload,
                post, display, share or otherwise make available on or through
                the Platform and you and your licensors (if any) are responsible
                for protecting those rights. We take no responsibility and
                assume no liability for Content you upload, post, display, or
                share on or through the Platform.{" "}
              </p>
              <p>
                <b>Copyright/DMCA Policy.</b> The Digital Millennium Copyright
                Act of 1998 (the "<b>DMCA</b>") provides recourse for copyright
                owners who believe that material appearing on the Internet
                infringes their rights under U.S. Copyright law. You may not
                post, distribute, or reproduce in any way any copyrighted
                material, trademarks, or other proprietary information without
                obtaining the prior written consent of the owner of such
                proprietary rights. Without limiting the foregoing, if you
                believe that your work has been copied and posted on the
                Platform, please contact us immediately at
                contact@needafaver.com. We reserve the right to terminate the
                Account of anyone found to be infringing one’s copyright or
                violating any provisions of these Terms.
              </p>
              <p>
                <b>Licensing your Content to Faver.</b> By posting or making
                your Content available via the Platform you grant Faver the
                license of the right to use, perform, display, reproduce,
                modify, and distribute such Content on and off the Platform
                including, but not limited to, Faver’s social media channels,
                mobile applications, and any other websites owned by Faver. When
                you remove any part of your Content from the Platform, we will
                remove any such part of Content from our servers as soon as it
                is practically possible.
              </p>
              <p>
                <b>Our Right to Remove Your Content.</b> We reserve the right at
                our sole discretion to remove any Content that we feel in our
                judgment does not comply with these Terms, along with any
                Content that we feel is otherwise offensive, harmful,
                objectionable, inaccurate, or violates any third party
                copyrights or trademarks. Moreover, we are not responsible for
                any delay or failure in removing such Content. If you post
                Content that we choose to remove, you hereby consent to waive
                any claim against us.
              </p>
              <h2 className="mt-4">SECTION 8: INDEPENDENT CONTRACTOR STATUS</h2>
              <p>
                Nothing in these Terms shall is intended to, or shall be
                construed to create a partnership, agency, joint venture,
                employment or similar relationship between (i) you and Faver; or
                (ii) you and another user of the Platform. Each Service Provider
                hereby acknowledges that Faver does not directly or indirectly
                engage it to render any Services whatsoever and that any
                engagement of any such Service Provider through the Platform is
                undertaken exclusively by Clients. Each Service Provider is and
                will remain an independent contractor in its relationship to
                each Client. Each Service Provider shall have the sole right and
                responsibility to determine the manner, method, and means of
                performance by which it will perform the Services, subject to
                any reasonable requests of its Clients. Notwithstanding the
                forgoing, each Service Provider agrees to adhere to any
                applicable policies and procedures as may be required by these
                Terms and any applicable law. Faver or Clients shall not be
                responsible for withholding any taxes with respect to Service
                Providers’ compensation received for Services. Service Providers
                shall not claim or seek any vacation pay, sick leave, retirement
                benefits, social security, worker’s compensation, health or
                disability benefits, unemployment insurance benefits, or
                employee benefits of any kind from their Clients or Faver.
              </p>
              <h2 className="mt-4">SECTION 9: FORCE MAJEURE</h2>
              <p>
                Any delay or failure of a Platform user or Faver to perform its
                obligations under these Terms will be excused if and to the
                extent that it was caused by an event or occurrence beyond any
                such user’s or Faver’s reasonable control and without its fault
                or negligence (“<b>Force Majeure</b>”). Force Majeure includes,
                but is not limited to, acts of God, actions by any government
                authority (whether valid or invalid), epidemics, pandemics,
                fires, floods, windstorms, explosions, riots, natural disasters,
                wars, sabotage, acts of terrorism, court injunction, or court
                order. If a user or Faver is claiming Force Majeure, any such
                user or Faver must provide the other users of the Platform with
                written notice of such delay (including the anticipated duration
                of the delay) within ten days of the occurrence of Force
                Majeure.
              </p>
              <h2 className="mt-4">
                SECTION 10: DISCLAIMERS; NO WARRANTY; LIMITED LIABILITY
              </h2>
              <p>
                We cannot guarantee and do not promise any specific results from
                use of the Platform or Services. The Platform and Services are
                provided on ‘as is’ and ‘as available’ basis, without any
                representation, warranties or conditions of any kind, either
                express or implied, including all implied warranties or
                conditions of merchantability, merchantable quality, fitness for
                a particular purpose, durability, title, and non-infringement.
                We do not warrant that your use of the Platform will be
                uninterrupted, timely, secure or error-free. We do not warrant
                that the quality of any Service will meet your expectations.
                Occasionally some information on the Platform may contain
                typographical errors, inaccuracies or omissions that may relate
                to Service descriptions, pricing, promotions, or offers.
              </p>
              <p>
                We reserve the right, at any time, to modify, suspend, or
                discontinue the operation of the Platform or any part thereof
                with or without notice. You agree that we will not be liable to
                you or to any third party for any modification, suspension, or
                discontinuance of operation of the Platform or any part thereof.
                Any future release, update, or other addition to any of
                functionalities of the Platform shall be subject to the terms
                and conditions of these Terms.
              </p>
              <p>
                We disclaim all, and assume no responsibility for, evaluating or
                verifying the accuracy, suitability, truthfulness or
                authenticity of any Content posted by any user on the Platform.
                We assume no responsibility for ensuring a user’s compliance
                with any applicable laws, rules and regulations or these Terms.
                We do not inspect premises or locations chosen by Platform users
                for Service performance.
              </p>
              <p>
                We make no representations or warranties as to the conduct of
                Platform users. You understand that we make no guarantees,
                either express or implied, regarding your ultimate experience
                with users you meet through the Platform. You do so at your own
                risk. Therefore, you are solely responsible for your
                interactions with other users of the Platform. You agree to take
                reasonable precautions in all interactions with other users of
                the Platform. We are not responsible for the use of any personal
                information that you publicly disclose using the Platform.
                Please carefully select the type of information that you post on
                the Platform.
              </p>
              <p>
                Under no circumstances will we or any of our employees,
                officers, agents, advertisers or affiliates be responsible for
                any loss or damage, including personal injury, emotional
                distress, death and/or any other damages resulting from your use
                of the Platform, Services, any Content posted on the Platform,
                or any interactions between you and other users of the Platform,
                whether online or offline. We disclaim all liability, regardless
                of the form of action, for the acts or omissions of Platform
                users (including unauthorized users), whether such acts or
                omissions occur during the use of the Platform or otherwise.
              </p>
              <h2 className="mt-4">SECTION 11: DISPUTE RESOLUTION</h2>
              <p>
                <b>Disputes Among Users.</b> You agree to use your best efforts
                to settle any dispute you may have with any other users of the
                Platform in an amicable way by mutual negotiations. However,
                should an amicable settlement between you and another user be
                impossible, you may pursue the issue independently. You
                acknowledge and agree that Faver will not and is not obligated
                to provide any dispute assistance under these Terms.
              </p>
              <p>
                <b>Disputes Between User and Faver.</b> Please read this section
                (hereinafter referred to as the “<b>Agreement to Arbitrate</b>”)
                carefully as it affects your rights and will have a substantial
                impact on how disputes between you and Faver will be resolved.
              </p>
              <p>
                You agree that any claim or dispute at law or equity that may
                arise between you and Faver relating in any way to or arising
                out of these or previous versions of the Terms, any policies
                incorporated herein by reference, your use of or access to the
                Platform will be resolved exclusively through final and binding
                arbitration, rather than in court. Alternatively, you may assert
                your claims in small claims court, if your claims qualify and so
                long as the matter remains in such court and advances only on an
                individual (non-class, non-representative) basis. The Federal
                Arbitration Act governs the interpretation and enforcement of
                this Agreement to Arbitrate. You and Faver further agree as
                follows:
              </p>
              <ol>
                <li>
                  <b>Applicable Law.</b> You and Faver agree that, except to the
                  extent inconsistent with or preempted by federal law, the laws
                  of the State of California, without regard to principles of
                  conflict of laws, will govern this Agreement to Arbitrate and
                  any claim or dispute that has arisen or may arise between you
                  and Faver, except as otherwise stated in these Terms.
                </li>
                <li>
                  <b>
                    Prohibition of Class and Representative Actions and
                    Non-Individualized Relief.
                  </b>{" "}
                  YOU AND FAVER AGREE THAT EACH ONE MAY BRING CLAIMS AGAINST THE
                  OTHER ONLY ON AN INDIVIDUAL BASIS AND NOT AS A PLAINTIFF OR
                  CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE ACTION
                  OR PROCEEDING. UNLESS BOTH YOU AND FAVER AGREE OTHERWISE, THE
                  ARBITRATOR MAY NOT CONSOLIDATE OR JOIN MORE THAN ONE PERSON’S
                  OR PARTY’S CLAIMS, AND MAY NOT OTHERWISE PRESIDE OVER ANY FORM
                  OF A CONSOLIDATED, REPRESENTATIVE, OR CLASS PROCEEDING. ALSO,
                  THE ARBITRATOR MAY AWARD RELIEF (INCLUDING MONETARY,
                  INJUNCTIVE, AND DECLARATORY RELIEF) ONLY IN FAVOR OF THE
                  INDIVIDUAL PARTY SEEKING RELIEF AND ONLY TO THE EXTENT
                  NECESSARY TO PROVIDE RELIEF NECESSITATED BY THAT PARTY’S
                  INDIVIDUAL CLAIM(S). ANY RELIEF AWARDED CANNOT AFFECT OTHER
                  PARTIES.
                </li>
                <li>
                  <b>Arbitration Procedures.</b> Arbitration is more informal
                  than a lawsuit in court. Arbitration uses a neutral arbitrator
                  instead of a judge or jury. However, an arbitrator can award
                  the same damages and relief on an individual basis that a
                  court can award to an individual. An arbitrator should apply
                  the terms of this Agreement to Arbitrate as a court would. All
                  issues are for the arbitrator to decide, except as prohibited
                  by law.
                  <br />
                  The arbitration will be conducted by the American Arbitration
                  Association ("<b>AAA</b>") under its rules and procedures,
                  including the AAA’s Consumer Arbitration Rules (as
                  applicable), as modified by this Agreement to Arbitrate. The
                  AAA’s rules are available at www.adr.org or by calling the AAA
                  at 1-800-778-7879. The use of the word "arbitrator" in this
                  provision shall not be construed to prohibit more than one
                  arbitrator from presiding over an arbitration; rather, the
                  AAA’s rules will govern the number of arbitrators that may
                  preside over an arbitration conducted under this Agreement to
                  Arbitrate.
                  <br />A party who intends to seek arbitration must first send
                  to the other, by certified mail, written Notice of Dispute ("
                  <b>Notice</b>"). The Notice must include a description of the
                  nature and basis of the claims the party is asserting and the
                  relief sought. The Notice to Faver should be sent to 11858
                  Goshen Ave., Apt 101 Los Angeles, CA 90049. Faver will send
                  any Notice to you to the physical address we have on file
                  associated with your Account; it is your responsibility to
                  keep your physical address up to date.
                  <br />
                  If you and Faver are unable to resolve the claims described in
                  the Notice amicably within 30 days after the Notice is
                  received, you or Faver may initiate arbitration proceedings. A
                  form for initiating arbitration proceedings is available on
                  the AAA’s site at www.adr.org. In addition to filing this form
                  with the AAA in accordance with its rules and procedures, the
                  party initiating the arbitration must mail a copy of the
                  completed form to the opposing party. Any settlement offer
                  made by you or Faver shall not be disclosed to an arbitrator.
                  <br />
                  The arbitration hearing shall be held in mutually agreed
                  location. If the value of the relief sought is $10,000 or
                  less, you or Faver may elect to have the arbitration conducted
                  by telephone or based solely on written submissions, which
                  election shall be binding on you and Faver subject to the
                  arbitrator’s discretion to require an in-person hearing, if
                  the circumstances warrant. In cases where an in-person hearing
                  is held, you and/or Faver may attend by telephone, unless the
                  arbitrator requires otherwise.
                  <br />
                  The arbitrator will decide the substance of all claims in
                  accordance with applicable law, including recognized
                  principles of equity, and will honor all claims of privilege
                  recognized by law. The arbitrator’s award shall be final and
                  binding and judgment on the award rendered by the arbitrator
                  may be entered in any court having jurisdiction thereof.
                </li>
                <li>
                  <b>Severability.</b> With the exception of any of the
                  provisions in Section "Prohibition of Class and Representative
                  Actions and Non-Individualized Relief" of this Agreement to
                  Arbitrate, if an arbitrator decides that any part of this
                  Agreement to Arbitrate is invalid or unenforceable, the other
                  parts of this Agreement to Arbitrate shall still apply. If an
                  arbitrator decides that any of the provisions in Section
                  "Prohibition of Class and Representative Actions and
                  Non-Individualized Relief" of this Agreement to Arbitrate is
                  invalid or unenforceable, then the entirety of this Agreement
                  to Arbitrate shall be null and void.
                </li>
                <li>
                  <b>Opt-Out Procedure.</b> If you are a new Platform user, you
                  can choose to reject this Agreement to Arbitrate by mailing us
                  a written opt-out notice ("<b>Arbitration Opt-Out Notice</b>
                  "). The Arbitration Opt-Out Notice must be postmarked no later
                  than thirty (30) days after the date you accept these Terms
                  for the first time. You must mail the Arbitration Opt-Out
                  Notice to 11858 Goshen Ave., Apt 101 Los Angeles, CA 90049.
                  You must complete the Arbitration Opt-Out Notice by providing
                  your full name, address (including street address, city, state
                  and zip code), and email address associated with the
                  Platform’s Account and state that you wish to opt out of this
                  Agreement to Arbitrate. You have to sign the Arbitration
                  Opt-Out Notice for it to be effective. This procedure is the
                  only way you can opt out of the Agreement to Arbitrate. If you
                  opt out of the Agreement to Arbitrate, all other parts of the
                  Terms will continue to apply to you. Opting out of this
                  Agreement to Arbitrate has no effect on any previous, other,
                  or future arbitration agreements that you may have with us.
                </li>
                <li>
                  <b>Future Amendments to the Agreement to Arbitrate.</b>{" "}
                  Notwithstanding any provision in this Agreement to Arbitrate
                  to the contrary, you and Faver agree that if Faver makes any
                  amendment to this Agreement to Arbitrate (other than an
                  amendment to any notice address provided herein) in the
                  future, that amendment shall not apply to any claim that was
                  filed in a legal proceeding against Faver prior to the
                  effective date of the amendment. The amendment shall apply to
                  all other disputes or claims governed by the Agreement to
                  Arbitrate that have arisen or may arise between you and Faver.
                  Any amendments to this Agreement to Arbitrate will take effect
                  when a revised version or a notification is posted on the
                  Platform unless otherwise stated. Your continued use of the
                  Platform after the revision date constitutes (a) your
                  acceptance of the revised Agreement to Arbitrate and (b)
                  agreement to be bound by any such revised terms and
                  conditions.
                </li>
                <li>
                  <b>Judicial Forum for Legal Disputes.</b> Unless you and we
                  agree otherwise, in the event that the Agreement to Arbitrate
                  above is found not to apply to you or to a particular claim or
                  dispute, either as a result of your decision to opt out of the
                  Agreement to Arbitrate or as a result of a decision by an
                  arbitrator order, you agree that any claim or dispute that has
                  arisen or may arise between you and Faver must be resolved
                  exclusively by a state or federal court located in the state
                  of California. You and Faver agree to submit to the personal
                  jurisdiction of the courts located within the County of Los
                  Angeles, California for the purpose of litigating all such
                  claims or disputes.
                </li>
              </ol>
              <h2 className="mt-4">SECTION 12: GENERAL PROVISIONS</h2>
              <p>
                <b>Term.</b> These Terms will remain in full force and effect
                while you use the Platform and/or are a registered user. You may
                deactivate your Account and thus terminate these Terms at any
                time and for any reason, by contacting Faver. We may terminate
                your Account if we find that you have breached these Terms.
                After your Account is terminated, all provisions that by their
                nature may survive termination of these Terms shall be deemed to
                survive such termination.
              </p>
              <p>
                <b>Non-Circumvention.</b> During the term of these Terms and for
                one year thereafter, no user shall, directly or indirectly,
                circumvent, initiate, solicit, negotiate, contract or enter into
                any business transactions with any other user introduced by us
                through the Platform, without our consent.{" "}
              </p>
              <p>
                <b>Privacy &amp; Security Policy.</b> Privacy and security of
                your personal information is very important to us. The Terms
                include and hereby incorporate by reference our Privacy Policy.
                To find out more on what type of information we collect and how
                we safeguard it please review our{" "}
                <a href="/privacy-policy">Privacy Policy.</a>
              </p>
              <p>
                <b>No Waiver.</b> Our failure to exercise or enforce any right
                or provision of these Terms shall not operate as a waiver of
                such right or provision.{" "}
              </p>
              <p>
                <b>Assignment.</b> We may assign, transfer or otherwise dispose
                of these Terms in whole or in part or any of our rights
                hereunder in connection with a merger, acquisition,
                reorganization or sale of all or substantially all of our
                assets, or other operation of law, without your consent. The
                terms and conditions of these Terms shall be binding upon
                assignees.
              </p>
              <p>
                <b>Severability.</b> If any provision of these Terms is, for any
                reason, held to be invalid, illegal, void or unenforceable, the
                remainder of the Terms, provisions, covenants and restrictions
                set forth herein shall remain in full force and effect and shall
                in no way be affected, impaired or invalidated, and the parties
                hereto shall use their commercially reasonable efforts to find
                and employ an alternative means to achieve the same or
                substantially the same result as that contemplated by such term,
                provision, covenant or restriction.
              </p>
              <p>
                <b>Consent to Electronic Notices.</b> You consent to the use of
                (a) electronic means to execute these Terms and to deliver any
                notices (including complaints) pursuant to these Terms, and (b)
                electronic records to store information related to these Terms
                or your use of the Platform or Services. Notices (including
                complaints) hereunder shall be invalid unless made in writing
                and given (a) by Faver via email (to the email address that you
                provide), (b) a posting on the Platform or (c) by you via email
                to{" "}
                <a href="mailto:contact@needafaver.com">
                  contact@needafaver.com
                </a>{" "}
                or to such other email addresses as Faver may specify in
                writing. The date of receipt will be deemed the date on which
                such notice is transmitted.
              </p>
              <h2 className="mt-4">CONTACT US</h2>
              <p>
                <b>Email:</b> contact@needafaver.com
                <br />
                <b>Mailing Address:</b> 11858 Goshen Ave., Apt 101 Los Angeles,
                CA 90049
                <br />
                <b>Phone:</b> 206-399-9179
              </p>
            </Container>
          </div>
          <Footer />
        </div>
      </>
    )
  }
}

export default Terms
